import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreItem } from '../../../types';
import { individualClientsRiskApi } from '../services';

export interface IndividualClientsProductsItemState {
  itemId?: string;
  item?: RiskScoreItem;
}

const initialState: IndividualClientsProductsItemState = {};

export const individualClientsProductsItemSlice = createSlice({
  name: 'individualClientsProductsItem',
  initialState,
  reducers: {
    clearProductRiskItemState: (state) => {
      state.itemId = undefined;
      state.item = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualClientsRiskApi.endpoints.getIndividualProduct.matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        state.item = action.payload.data;
        state.itemId = action.payload.data.id;
      },
    );
  },
});

export const { clearProductRiskItemState } =
  individualClientsProductsItemSlice.actions;

export default individualClientsProductsItemSlice.reducer;
